import React from "react";
import { InterviewSidebarSection } from "../Components/InterviewSidebarSection";
import { RowWithSingleField, YesNoRow } from "../Components/SidebarComponents";
import { isNullOrWhitespace } from "../../../../services/stringService";

//TODO: Add appropriate logic here.
export const InterviewSidebarExchange = ({ ...props }) => {
    return (
        <InterviewSidebarSection title={"Exchange"} {...props}>
            <div />
        </InterviewSidebarSection>
    );
};
